import React from 'react';
import FigtreeArchitectureDemo from '../components/FigtreeArchitectureDemo';

export default function ArchitecturePage() {
  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <div className="px-4 py-6 sm:px-0">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">System Architecture</h1>
        
        {/* Architecture Visualization */}
        <FigtreeArchitectureDemo isProcessing={false} currentStage="" />
        
        {/* Additional Architecture Information */}
        <div className="mt-8 bg-white shadow rounded-lg p-6">
          <h2 className="text-lg font-medium text-gray-900 mb-4">CrewAI Multi-Agent System</h2>
          <div className="prose max-w-none">
            <p className="text-gray-600 mb-4">
              Figtree leverages the power of CrewAI to orchestrate a sophisticated multi-agent system specifically designed for tourism and hospitality content generation. Each agent has specialised knowledge and capabilities that work together to create exceptional marketing content.
            </p>
            
            <div className="grid md:grid-cols-2 gap-6 mt-6">
              <div>
                <h3 className="text-md font-semibold text-gray-900 mb-2">Agent Workflow</h3>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li>• <strong>Sequential Processing:</strong> Agents work in a defined order for optimal results</li>
                  <li>• <strong>Task Specialisation:</strong> Each agent focuses on their area of expertise</li>
                  <li>• <strong>Context Sharing:</strong> Information flows seamlessly between agents</li>
                  <li>• <strong>Quality Assurance:</strong> Multiple validation layers ensure high-quality output</li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-md font-semibold text-gray-900 mb-2">Technology Stack</h3>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li>• <strong>CrewAI:</strong> Multi-agent orchestration framework</li>
                  <li>• <strong>FastAPI:</strong> High-performance Python web framework</li>
                  <li>• <strong>React:</strong> Modern frontend user interface</li>
                  <li>• <strong>OpenAI:</strong> Advanced language model capabilities</li>
                  <li>• <strong>Weather API:</strong> Real-time contextual data integration</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}